import React from 'react';
import { connect } from 'react-redux';

import Entities from '../common/Entities';
import CategoriesTable from './CategoriesTable';
import CategoryEditModal from './CategoryEditModal';
import {
    fetchCategories as fetchCategoriesAction,
    updateCategory as updateCategoryAction,
    createCategory as createCategoryAction,
    clearCreateCategory as clearCreateCategoryAction,
    clearUpdateCategory as clearUpdateCategoryAction
} from '../../actions/categories';

import * as permissions from '../../constants/permissions';

let CategoriesTab = class extends React.Component {
    constructor(props) {
        super(props);

        this._loadCategories = this._loadCategories.bind(this);
        this._createCategory = this._createCategory.bind(this);
        this._updateCategory = this._updateCategory.bind(this);
        this._clearCrudAction = this._clearCrudAction.bind(this);
    }

    componentDidMount() {
        this._loadCategories();
    }

    _loadCategories() {
        this.props.fetchCategoriesAction();
    }

    _createCategory(category) {
        this.props.createCategoryAction(category);
    }

    _updateCategory(category) {
        this.props.updateCategoryAction(category);
    }

    _clearCrudAction(isNew) {
        isNew ? this.props.clearCreateCategoryAction() : this.props.clearUpdateCategoryAction();
    }


    render() {
        const { categories, fetching, createFetching, updateFetching, updateResult, createResult } = this.props;
        const entities = categories.sort((prev, next) => prev.Name < next.Name ? -1 : 1);
        return (
            <div>
                <Entities
                    entities={entities}
                    fetching={fetching}
                    createFetching={createFetching}
                    updateFetching={updateFetching}
                    contentTable={CategoriesTable}
                    editModal={CategoryEditModal}
                    createAction={this._createCategory}
                    updateAction={this._updateCategory}
                    clearCrudAction={this._clearCrudAction}
                    loadAction={this._loadCategories}
                    header='Категории'
                    updateError={updateResult}
                    createError={createResult}
                    createDisabled={!permissions.isAllowedFor(permissions.allowedEditServices)}
                />
            </div>);
    }
}

CategoriesTab = connect(state => {
    const category = state.application.get('serviceCategory').get('category');
    return { ...category };
}, {
    fetchCategoriesAction,
    updateCategoryAction,
    createCategoryAction,
    clearCreateCategoryAction,
    clearUpdateCategoryAction
})(CategoriesTab);

export default CategoriesTab;


// WEBPACK FOOTER //
// ./src/components/services/CategoriesTab.jsx